import { debounce as $debounce } from '@/utils/utils'

export const debounced = (wait = 500) => {
  return (target, key, descriptor) => {
    descriptor.value = $debounce(descriptor.value, wait)
  }
}
